import React from 'react'
import { FeaturesSection } from '../components/Home/FeaturesSection'
import { LastSection } from '../components/Home/LastSection'
import { WelcomeSection } from '../components/Home/WelcomeSection'
import FooterOutside from '../components/Layout/FooterOutside'
import { Navbar } from '../components/Navbar/Navbar'
import { SEO } from '../components/seo'
import { redirectToMeetingBaas, transcriptSeeker } from '../utils/router'

const Home = () => {
    return (
        <main className="snap-mandatory">
            <SEO
                title="Meeting Integration API 🐟 | Interact and get data"
                description="Use our meeting bots as a service to integrate with meeting providers. Scale instantly."
                isHomePage={true}
            />
            <div className=" overflow-y-scroll h-screen min-h-screen min-w-screen max-w-screen overflow-x-hidden bg-neutral-50">
                <Navbar />
                <WelcomeSection
                    title1="Integrate with Meetings"
                    title2=""
                    title3="through one API"
                    subtitle1="One API for Google Meet, Zoom, and Microsoft Teams."
                    subtitle2="Integrate all of your tools automatically."
                    buttonName="Get Started through Meeting BaaS 🐟"
                    secondButtonName="Try Demo"
                    onButtonClick={redirectToMeetingBaas}
                    onSecondButtonClick={transcriptSeeker}
                />
                {/* <MeetingBotAPIContent path={'transcription-api'}></MeetingBotAPIContent> */}
                {/* <HomeSpokeBot></HomeSpokeBot> */}
                <FeaturesSection />
                <LastSection />
                <FeaturesSection />
                <LastSection />
                <div className="snap-start min-w-screen max-w-screen overflow-x-hidden bg-neutral-900">
                    <FooterOutside />
                </div>
            </div>
        </main>
    )
}
export default Home
